import { selectOrderId, useOrderTables } from 'entities/orders';
import { Order } from 'entities/orders/model/types';
import { FC } from 'react';
import { Flex } from 'shared/ui/flex';
import { RecourceButton } from '../../buttons/resourceButton';
import { RecourcesContainer } from './styles';
import { TagCard } from 'shared/ui/cards/tagCard';
import { useAppSelector } from 'shared/lib/store';
import { MAIN_COLOR } from 'shared/consts';
import { Img } from 'shared/ui/imgStyledComponent';
import lock from 'assets/icons/outloned-lock-red.svg';

export const OrderResources: FC<{
	order: Order;
	row?: boolean;
}> = ({ order, row }) => {
	const {
		isOverflowTables,
		overflowTablesCount,
		showTables,
		isShowAllTables
	} = useOrderTables(order);
	const selectedOrderId = useAppSelector(selectOrderId);

	if (!showTables.length) {
		return null;
	}


	if (row) {
		return (
			<Flex $gap="4px" $wrap={isShowAllTables ? 'wrap' : 'nowrap'} $alignItems="center">
				{showTables?.map(table => (
					<RecourceButton key={table} order={order} withBorder={order.conflicts?.map(resource => resource.name).includes(table)}>
						{table}
					</RecourceButton>
				))}
				{isOverflowTables && (
					<TagCard
						name={`+${overflowTablesCount}`}
						variant="bordered"
						border={selectedOrderId === order.id
							? MAIN_COLOR
							: 'transparent'
						}
						outputCloseButton={false}
						typographyProps={{
							colorVariant: 'main',
							isBold: true,
							pointer: true,
							mode: "smaller"
						}}
					/>
				)}
				{order.appointment.hold_resources && (
					<Img src={lock} $size="verySmall" />
				)}
			</Flex>
		)
	}

	return (
		<RecourcesContainer>
			{showTables?.map(table => (
				<RecourceButton key={table} order={order}>
					{table}
				</RecourceButton>
			))}
			{isOverflowTables && (
				<TagCard
					name={`+${overflowTablesCount}`}
					variant="bordered"
					border={selectedOrderId === order.id
						? MAIN_COLOR
						: 'transparent'
					}
					outputCloseButton={false}
					typographyProps={{
						colorVariant: 'main',
						isBold: true,
						pointer: true,
						mode: "smaller"
					}}
				/>
			)}
			{order.appointment.hold_resources && (
				<Img src={lock} $size="verySmall" />
			)}
		</RecourcesContainer>
	);
};
